<template>
    <div id="app">
        <router-view/>
        <Footer/>
    </div>
</template>

<script>
import Footer from './components/footer/index';
export default {
    components: {
        Footer
    }
};
</script>
<style lang="less">
    // 公共导航

    .common-header-nav {
        .el-icon-s-home {
            margin-right: 10px;
            color: #c4c4c4;
            font-size: 16px;
        }
        .el-icon-caret-right {
            margin-right: 10px;
            color: #c4c4c4;
        }
        .common-header-nav-title {
            font-size: 14px;
            color: #333333;
        }
        .comon_disbble {
            color: #aaa !important;
        }
    }
</style>
